(function () {
  'use strict';

  function directChild(element, selector) {
    if (!element) return null;
    return Array.prototype.find.call(element.children, function (child) {
      return child.matches(selector);
    }) || null;
  }

  function directChildren(element, selector) {
    if (!element) return [];
    return Array.prototype.filter.call(element.children, function (child) {
      return child.matches(selector);
    });
  }

  function initProductsMega(root) {
    if (!root || root.__fireflyProductsV2Init) return;
    root.__fireflyProductsV2Init = true;

    var isMobile = root.getAttribute('data-products-mega-v2-variant') === 'mobile';
    var categoryTriggerSelector = isMobile
      ? '[data-products-v2-category-trigger].products-mega-v2__trigger--mobile'
      : '[data-products-v2-category-trigger].products-mega-v2__trigger--desktop';
    var subcategoryTriggerSelector = isMobile
      ? '[data-products-v2-subcategory-trigger].products-mega-v2__trigger--mobile'
      : '[data-products-v2-subcategory-trigger].products-mega-v2__trigger--desktop';
    var inner = root.querySelector('.products-mega-v2__inner');
    var primaryView = root.querySelector('.products-mega-v2__primary-view');
    var categoryList = root.querySelector('.products-mega-v2__category-list');
    var categories = directChildren(categoryList, '[data-products-v2-category]');
    var heightFrame = 0;

    function subcategoriesFor(category) {
      var panel = directChild(category, '[data-products-v2-category-panel]');
      var list = panel ? panel.querySelector('.products-mega-v2__subcategory-list') : null;
      return directChildren(list, '[data-products-v2-subcategory]');
    }

    function setExpanded(item, selector, expanded) {
      directChildren(item, selector).forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    function activateSubcategory(category, subcategory) {
      var subcategories = subcategoriesFor(category);
      subcategories.forEach(function (item) {
        var active = item === subcategory;
        item.classList.toggle('is-active', active);
        setExpanded(item, '[data-products-v2-subcategory-trigger]', active);
      });
    }

    function activateCategory(category) {
      categories.forEach(function (item) {
        var active = item === category;
        item.classList.toggle('is-active', active);
        setExpanded(item, '[data-products-v2-category-trigger]', active);
      });

      if (category) {
        var subcategories = subcategoriesFor(category);
        var current = subcategories.find(function (item) { return item.classList.contains('is-active'); });
        activateSubcategory(category, current || subcategories[0] || null);
      }
    }

    function activeMobileView() {
      if (!isMobile) return null;

      var category = categories.find(function (item) { return item.classList.contains('is-active'); });
      if (!category || !root.classList.contains('is-category-open')) return primaryView;

      var categoryPanel = directChild(category, '[data-products-v2-category-panel]');
      var secondaryView = categoryPanel ? directChild(categoryPanel, '.products-mega-v2__secondary-view') : null;
      if (!root.classList.contains('is-content-open')) return secondaryView || primaryView;

      var subcategory = subcategoriesFor(category).find(function (item) { return item.classList.contains('is-active'); });
      return subcategory ? directChild(subcategory, '[data-products-v2-content-panel]') : (secondaryView || primaryView);
    }

    function syncMobileHeight(immediate) {
      if (!isMobile || !inner) return;

      if (heightFrame) window.cancelAnimationFrame(heightFrame);
      var update = function () {
        heightFrame = 0;
        var view = activeMobileView();
        if (!view) return;
        var viewHeight = Math.ceil(view.getBoundingClientRect().height);
        var drawer = root.closest('.firefly-mobile-drawer');
        var availableHeight = 0;

        if (drawer) {
          var drawerRect = drawer.getBoundingClientRect();
          var innerRect = inner.getBoundingClientRect();
          availableHeight = Math.max(0, Math.floor(drawerRect.bottom - innerRect.top));
        }

        var mobileHeight = root.classList.contains('is-content-open') && availableHeight > 0
          ? availableHeight
          : Math.max(viewHeight, availableHeight);

        inner.style.setProperty('--products-v2-mobile-height', mobileHeight + 'px');
      };

      if (immediate) update();
      else heightFrame = window.requestAnimationFrame(update);
    }

    function alignMobileDrawerItem() {
      if (!isMobile) return;

      var navigationItem = root.closest('.navigation__item--products-mega');
      var drawerBody = root.closest('.firefly-mobile-drawer__body');
      if (!navigationItem || !drawerBody) return;

      var itemRect = navigationItem.getBoundingClientRect();
      var bodyRect = drawerBody.getBoundingClientRect();
      var targetScrollTop = drawerBody.scrollTop + itemRect.top - bodyRect.top;
      drawerBody.scrollTop = Math.max(0, Math.round(targetScrollTop));
    }

    function resetMobile() {
      root.classList.remove('is-category-open', 'is-content-open');
      activateCategory(categories[0] || null);
      syncMobileHeight();
    }

    categories.forEach(function (category) {
      var categoryTrigger = directChild(category, categoryTriggerSelector);
      if (!categoryTrigger) return;

      if (isMobile) {
        categoryTrigger.addEventListener('click', function (event) {
          event.preventDefault();
          activateCategory(category);
          root.classList.add('is-category-open');
          if (category.hasAttribute('data-products-v2-category-direct')) {
            alignMobileDrawerItem();
            root.classList.add('is-content-open');
          } else {
            root.classList.remove('is-content-open');
          }
          syncMobileHeight();
        });
      } else {
        categoryTrigger.addEventListener('mouseenter', function () { activateCategory(category); });
        categoryTrigger.addEventListener('focus', function () { activateCategory(category); });
      }

      subcategoriesFor(category).forEach(function (subcategory) {
        var subcategoryTrigger = directChild(subcategory, subcategoryTriggerSelector);
        if (!subcategoryTrigger) return;

        if (isMobile) {
          subcategoryTrigger.addEventListener('click', function (event) {
            event.preventDefault();
            activateCategory(category);
            activateSubcategory(category, subcategory);
            alignMobileDrawerItem();
            root.classList.add('is-category-open', 'is-content-open');
            syncMobileHeight();
          });
        } else {
          subcategoryTrigger.addEventListener('mouseenter', function () {
            activateCategory(category);
            activateSubcategory(category, subcategory);
          });
          subcategoryTrigger.addEventListener('focus', function () {
            activateCategory(category);
            activateSubcategory(category, subcategory);
          });
        }
      });
    });

    if (isMobile) {
      root.addEventListener('click', function (event) {
        var close = event.target.closest('[data-products-v2-close]');
        if (close && root.contains(close)) {
          event.preventDefault();
          var navigationItem = root.closest('.navigation__item--products-mega');
          var outerToggle = navigationItem ? directChild(navigationItem, '.navigation__children-toggle') : null;
          if (outerToggle && navigationItem.classList.contains('navigation__item--open')) outerToggle.click();
          resetMobile();
          return;
        }

        var back = event.target.closest('[data-products-v2-back]');
        if (!back || !root.contains(back)) return;

        event.preventDefault();
        var category = back.closest('[data-products-v2-category]');
        if (category && category.hasAttribute('data-products-v2-category-direct')) {
          root.classList.remove('is-category-open', 'is-content-open');
        } else if (back.getAttribute('data-products-v2-back') === 'categories') {
          root.classList.remove('is-category-open', 'is-content-open');
        } else {
          root.classList.remove('is-content-open');
        }
        syncMobileHeight();
      });

      if (window.ResizeObserver) {
        var resizeObserver = new ResizeObserver(function () {
          syncMobileHeight();
        });
        root.querySelectorAll('.products-mega-v2__primary-view, .products-mega-v2__secondary-view, .products-mega-v2__content-panel').forEach(function (view) {
          resizeObserver.observe(view);
        });
      }

      root.addEventListener('load', function () { syncMobileHeight(); }, true);
      window.addEventListener('resize', function () { syncMobileHeight(); }, { passive: true });

      var navigationItem = root.closest('.navigation__item--products-mega');
      if (navigationItem && window.MutationObserver) {
        new MutationObserver(function () {
          if (!navigationItem.classList.contains('navigation__item--open')) resetMobile();
          else syncMobileHeight();
        }).observe(navigationItem, { attributes: true, attributeFilter: ['class'] });
      }

      var drawer = root.closest('.firefly-mobile-drawer');
      if (drawer && window.MutationObserver) {
        new MutationObserver(function () {
          if (drawer.getAttribute('aria-hidden') === 'true') resetMobile();
        }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
      }
    }

    activateCategory(categories[0] || null);
    syncMobileHeight(true);
  }

  function renderMounts() {
    var template = document.querySelector('[data-products-mega-v2-template]');
    if (!template || !template.content) return;

    document.querySelectorAll('[data-products-mega-v2-mount]').forEach(function (mount) {
      var context = mount.getAttribute('data-products-mega-v2-mount') === 'mobile' ? 'mobile' : 'desktop';
      var fragment = template.content.cloneNode(true);

      mount.replaceChildren(fragment);
      var root = mount.querySelector('[data-products-mega-v2]');
      if (!root) return;

      root.classList.add('products-mega-v2--' + context);
      root.setAttribute('data-products-mega-v2-variant', context);
      initProductsMega(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderMounts);
  } else {
    renderMounts();
  }

  document.addEventListener('shopify:section:load', function () {
    window.requestAnimationFrame(renderMounts);
  });

  document.addEventListener('shopify:section:unload', function () {
    window.requestAnimationFrame(renderMounts);
  });
})();
